module.exports = __webpack_public_path__ + "img/ennetix-teams-tab2.265a765d.png";